
import {useEffect,useState} from 'react'
import React from 'react';
import ContentLoader from 'react-content-loader'
import { getPropertiesAction,changeOffsetPropertiesAction } from '../redux/propertiesDucks';
import { connect } from 'react-redux'
import { graphql, useStaticQuery } from 'gatsby';
import { useLocation } from '@reach/router';
import $ from 'jquery'
import useQueryProperties from '../hooks/useQueryProperties';

const PaginatedItems = ({orders,coordinates,polygonCoordinates,offset,dispatch,filters}) => {
    
  const { realEstate } = useStaticQuery(graphql`
    query {
      realEstate {
        keys {
          tokko
        }
      }
    }
  `)

  const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(offset / itemsPerPage);
  const [items, setItems] = useState([0,1,2]);
  const [fixed,setFixed] = useState(false)
  const { data: properties, isLoading: isLoadingProperties, isFetching: isFetchingProperties } = useQueryProperties({ filters,polygonCoordinates,coordinates,orders,offset })
  // const { data: properties, isLoading: isLoadingProperties, isFetching: isFetchingProperties } = useGetPropertiesQuery({
  //   "API_KEY":realEstate.keys.tokko,
  //   "params_get":makeParamsGetByFilters(orders,offset,polygonCoordinates) + makeFormDataByFilters(filters,coordinates,polygonCoordinates),
  //   "body":makeParamsCoordinates(coordinates,polygonCoordinates)
  // });

  const location = useLocation()

  const getItems = (data) => {
    let items=[]
    if(properties?.objects?.length > 50){
      return items
    }
    for (let index = 0; index < Math.ceil(data/itemsPerPage); index++) {
      items.push(index)
    }
    return items ;
  } 

  useEffect(() => {
    setItems(getItems(properties?.meta?.total_count))
    if(properties?.meta?.total_count > 0){
      setFixed(true)
    }
    if(offset === 0){
      setCurrentPage(0)
    }
  },[offset,properties?.meta?.total_count])

  useEffect(() => {
    dispatch(changeOffsetPropertiesAction(currentPage*itemsPerPage))
    // if(location.pathname.includes(filters.operation.toLowerCase())){
      // dispatch(getPropertiesAction())
    // }
  },[currentPage])


    return items.length > 1 && (
      <>
            <div className="mt-4 pt-0 pagination d-flex align-items-center flex-column justify-content-center">
              {!fixed ? 
                <ContentLoader 
                  speed={2}
                  width={500}
                  height={100}
                  viewBox="0 0 500 100"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                >
                  <rect x="58" y="2" rx="15" ry="15" width="235" height="50" /> 
                  <circle cx="27" cy="27" r="22" /> 
                  <circle cx="323" cy="26" r="22" />
                </ContentLoader>
                :
                <>
                  <div id="paginator" className="d-flex align-items-center justify-content-center">
                    {/* <div onClick={() => setCurrentPage( ? items[items.length-1] : currentPage-1)} className={"cursor-pointer pagination-item d-flex justify-content-center align-items-center " + (currentPage === 0 ? 'opacity-disabled' : '')}> */}
                    <div onClick={() =>  $("html, body").animate({ scrollTop: 0 }, "slow") + (items[0] !== currentPage ? setCurrentPage(currentPage-1) : '')} className={"cursor-pointer pagination-item d-flex justify-content-center align-items-center " + (currentPage === 0 ? 'opacity-disabled' : '')}>
                        {""}
                    </div>
                    <div className="container-pagination d-flex align-items-center">
                        {/* <div className={"item-paginate points  " + (currentPage > (items[0]+1) ? '' : ' opacity ')}>
                            ...
                        </div> */}
                        <div className={"item-paginate opacity " + (currentPage === items[0] ? '' : ' d-none ')}>
                            0-000
                        </div>
                        {items.map((item, index) => (
                          <div onClick={() =>  $("html, body").animate({ scrollTop: 0 }, "slow") + setCurrentPage(item)} className={"item-paginate " + (item === currentPage && ' active') + (currentPage === item || currentPage === item+1 || currentPage === item-1 ? '' : ' d-none ')}>
                              {item > 0 ? item*itemsPerPage + 1 : item*itemsPerPage} a {((item+1)*itemsPerPage > properties?.meta?.total_count ? properties?.meta?.total_count : (item+1)*itemsPerPage)}
                          </div>
                        ))}
                        <div className={"item-paginate opacity " + (currentPage === items[items.length -1] ? '' : ' d-none ') }>
                            0-000
                        </div>
                        {/* <div className={"item-paginate points end  " + (currentPage < (items[items.length-1]-1) ? '' : ' opacity ')}>
                            ...
                        </div> */}
                    </div>
                    <div onClick={() => $("html, body").animate({ scrollTop: 0 }, "slow") + (items[items.length-1] !== currentPage ? setCurrentPage(currentPage+1) : '')} className={"cursor-pointer next pagination-item d-flex justify-content-center align-items-center " + (currentPage === items[items.length-1] ? 'opacity-disabled' : '')}>
                        {""}
                    </div>
                  </div>
                  <h5 className='d-block mt-lg-2 mt-1'>{isLoadingProperties || isFetchingProperties ? 'Cargando resultados..' : <><strong> {properties?.meta?.total_count} </strong> de <strong>{filters.operation === 'venta' ? properties?.meta?.total_count : properties?.meta?.total_count}</strong>  propiedades en {filters.operation}</>}</h5>
                </>
              }

            </div>

      </>
    );
  }

  export default connect(state => ({
    totalCount: state.properties.totalCount,
    totalListFilters: state.properties.totalListFilters,
    totalCountAlquiler: state.properties.totalCountAlquiler,
    totalCountVenta: state.properties.totalCountVenta,
    offset: state.properties.offset,
    filters: state.properties.filters,
    loading: state.properties.loading,
    orders: state.properties.orders,
    coordinates: state.properties.coordinates,
    polygonCoordinates: state.properties.polygonCoordinates,

}),null)(PaginatedItems);